import $ from 'jquery';
import length from 'ramda/src/length';
import lt from 'ramda/src/lt';
import curry from 'ramda/src/curry';
import compose from 'ramda/src/compose';
import { HeaderSearchResult } from './components/HeaderSearchResult';
import Vue from 'vue';
import { timeout300 } from './utils/timeout';

const lessThan3 = curry(lt)(3);
const minQueryLength = compose(
	lessThan3,
	length
);

$(function() {
	const $search = $('[data-header-search]');
	const resultArea = new Vue({
		data: () => ({
			content: '',
		}),
		computed: {
			isVisible: (vm) => vm.$refs.result.isVisible,
		},
		methods: {
			show() {
				this.$refs.result.show();
			},
			hide() {
				this.$refs.result.hide();
			},
		},
		render() {
			return (
				<HeaderSearchResult ref="result" title="Поиск во всех разделах">
					<div domPropsInnerHTML={ this.content }></div>
				</HeaderSearchResult>
			);
		},
	});

	resultArea.$mount();

	$search.each(function() {
		(new Search($(this))).init();
	});

	function Search($el) {
		if ($el.length < 1) return;

		const self = this;
		const prefix = 'header-search';
		const $form = $el.find('form');
		const $input = $form.find('input');
		const $resultArea = $el.find(`.${prefix}__result`);
		const apiUrl = $input.attr('data-api-url') || false;

		$resultArea.replaceWith(resultArea.$el);

		if (!apiUrl) return;

		const appleResult = result => {
			if (result) {
				resultArea.content = result;
				if (!resultArea.isVisible) resultArea.show();
			} else {
				timeout300(() => resultArea.content = '');
			}
		}

		const requestResult = query => {
			if (!query) return;

			const data = {};
			data['Q'] = query;

			$.post(apiUrl, data)
				.done(res => {
					if (res.status && res.html) appleResult(res.html);
					else {
						resultArea.hide();
						appleResult();
					}
				})
				.fail(res => {
					console.log(res);
					resultArea.hide();
				})
		}

		const search = (value) => {
			if (!minQueryLength(value)) {
				if (resultArea.isVisible) resultArea.hide();
				appleResult();
				return;
			}

			requestResult(value);
		}

		this.init = () => {
			let typingTimer;

			const idleSearch = (event) => {
				typingTimer = timeout300(() => search(event.target.value));
			}
			const resetIdle = () => clearTimeout(typingTimer);

			$input.on('keydown focus blur', resetIdle);
			$input.on('keyup focus', idleSearch);
			$input.on('blur', () => resultArea.hide());
		}
	}
});
